import "reflect-metadata";
import {inject, injectable} from "inversify";
import {PlanExtensionsCatalogRepository} from "@dropDesk/domain/repositories/plan_extensions/plan_extensions_catalog.repository";
import {CompanyExtensionEntity} from "@dropDesk/domain/entities/plan_extensions/company_extension.entity";

@injectable()
export class HirePlanExtensionUseCase {
    private _repository: PlanExtensionsCatalogRepository;

    constructor(@inject(PlanExtensionsCatalogRepository) repository: PlanExtensionsCatalogRepository) {
        this._repository = repository;
    }

    public call(idExtension: string): Promise<CompanyExtensionEntity> {
        return this._repository.hire(idExtension);
    }
}
